  <!-- The Modal-->
  <div class="modal" id="enrolAdminExtendModal">

    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header gold-bg">
          <h4 class="modal-title">
            <span class="glyphicon glyphicon-lock"></span>
            Boldungu Extend Enrolment ({{studentDetail.fullname}})
          </h4>
        <button type="button" class="btn btn-danger" (click)="closeModal()">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data">
          <div class='form-group row mb-2' id="coupon" *ngIf="studentDetail.server_enrolment_id!=0">
            <label class='control-label col-sm-3'> Days</label>
            <div class='col-sm-8'><input name='days' placeHolder='Days' class='form-control' formControlName="days"></div>
          </div>
          <fieldset class="buttons text-center">
            <button type="submit" class="btn btn-primary margin-50-right">
              <span *ngIf="extending" class="spinner-border spinner-border-sm me-1"></span>
              Submit</button>
            <button type="button" class="btn btn-danger" (click)="closeModal()">Close</button>
          </fieldset>
        </form>
      </div>
    </div>
    </div>
  </div>
